export default __webpack_public_path__ + "static/media/l_wdt_c_3.ca7b825b.mp3";